import { isExactMatch } from '../shared.js';
import { isSamePrescription } from './prescription.js';

const areSamePrescriptionGlassesLineItem = (serverLineItem, draftLineItem)=>{
    var ref;
    if (serverLineItem.__typename !== 'LineItemBundle') {
        return false;
    }
    if (((ref = serverLineItem.typeDetails) === null || ref === void 0 ? void 0 : ref.__typename) !== 'BundlePrescriptionGlassesTypeDetails') {
        return false;
    }
    const serverSkus = new Set(serverLineItem.bundleLineItems.map((bl)=>bl.legacyProduct.sku
    ));
    const draftSkus = new Set([
        draftLineItem.sku,
        ...draftLineItem.bundleLineItems.map((b)=>b.sku
        )
    ]);
    return isExactMatch(serverSkus, draftSkus) && isSamePrescription(serverLineItem.typeDetails, draftLineItem.prescription);
};

export { areSamePrescriptionGlassesLineItem };
//# sourceMappingURL=prescription-glasses-bundle.js.map
